<template>
  <div class="app-container">
    <div class="sensitive-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="sensitive-list-filter-value" placeholder="敏感词" @keyup.enter.native="searchChange" v-model.trim="keyword" clearable size="small"></el-input>
          </div>
        </el-col>
        <div>
          <el-button class="sensitive-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
          <el-button class="sensitive-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
        </div>
      </el-row>
    </div>

    <basic-container>
      <avue-crud :data="data" :option="tableOption" :page.sync="page" @on-load="onLoad" @row-update="update" @row-del="delWords">
        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.sensitive_words_add">新增</el-button>
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog title="新增敏感词" v-if="showAddDialog" :visible="showAddDialog" @close="handleAddDialogClose" :close-on-click-modal="false">
      <div class="input-area">
        <el-input v-model.trim="newWords" placeholder="请输入敏感词, 最多可输入45个字" :maxlength="45" @keyup.enter.native="save"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddDialog = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import { tableOption } from '@/const/crud/sensitive/sensitive'
import { getWordsPage, saveWords, updateWords, deleteWords} from '@/api/sensitive/sensitive'

export default {
  data() {
    return {
      search: {},
      keyword: '',
      page:{
        total: 0,
        pageSize: 10,
        pagerCount: 0
      },
      data: [],
      tableOption: tableOption,
      showAddDialog: false,
      newWords: '',
    }
  },
  methods: {
    async baseGet() {
      const params = {};
      params.size = this.page.pageSize;
      params.current = this.page.currentPage;
      params.word = this.keyword;

      const response = await this.requestWrapper(getWordsPage, params);
      if (!response || response.ok === false) {
        this.$message({
          message: '获取敏感词失败',
          type: 'error'
        });
        return;
      }
      this.data = response.data.records;
      this.page.total = response.data.total;
      this.formData();
    },
    searchReset () {
      this.keyword = '';
      this.searchChange();
    },
    searchChange () {
      this.page.currentPage = 1;
      this.baseGet();
    },
    async delWords (row,index) {
      this.$confirm('此操作将永久删除该敏感词, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const response = await this.requestWrapper(deleteWords, row.id);
        if (!response || response.ok === false) {
          this.$message({
            message: response.message,
            type: 'error'
          });
          return;
        } else {
          this.$message({
            message: '删除敏感词成功',
            type: 'success'
          });
          this.baseGet();
        }
      });
    },
    async update (row,index,done,loading) {
      const response = await this.requestWrapper(updateWords, row);
      if (!response || response.ok === false) {
        this.$message({
          message: response.message,
          type: 'error'
        });
        loading();
        return;
      } else {
         this.$message({
          message: '编辑敏感词成功',
          type: 'success'
        });
        done();
        this.baseGet();
      }
    },
    async save () {
      if (this.newWords === '' || this.newWords.trim() === '') {
        this.$message({
          message: '敏感词不能为空',
          type: 'info'
        });
        return;
      }
      const data = {}
      data.word = this.newWords;
      const response = await this.requestWrapper(saveWords, data);
      if (!response || response.ok === false) {
        this.$message({
          message: response.message,
          type: 'error'
        });
        return;
      } else {
        this.$message({
          message: '添加敏感词成功',
          type: 'success'
        });
        this.page.currentPage = 1;
        this.baseGet();
      }
      this.showAddDialog = false;
      this.newWords = '';
    },
    handleAddDialogClose () {
      this.showAddDialog = false;
    },
    handleAdd () {
      this.showAddDialog = true;
    },
    onLoad (page) {
      this.page.pageSize = page.pageSize;
      this.page.currentPage = page.currentPage;
      this.baseGet();
    },
    formData() {
      this.data.forEach(item => {
        if (!item.creator) {
          if (item.insertType === 0) {
            item.creator = '系统自动识别'
          } else {
            item.creator = '-'
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  }
}
</script>

<style lang="scss" scoped>
.sensitive-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      margin-left: 10px;
    }
    &-search {
      margin-left: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
</style>